module.exports = __webpack_public_path__ + "img/bg-6.b3972782.jpg";